// src/utils/productPricing.js
//
// THE single answer to "what does this product cost on this dining option?"
//
// A product may carry a second price (Product.secondary_price) and each dining
// option selects a tier (DiningOption.price_tier). Client request 2026-08-26:
// "a different price for in-store and delivery".
//
// Imports NOTHING on purpose, so both tills and any receipt/kitchen-ticket
// path can use it without dragging in axios (whose ESM build Jest cannot parse
// unmocked) — same discipline as utils/transactionLines.js and
// utils/splitBillTotals.js.
//
// Every place that reads a price must go through this. A price that is correct
// in the cart but not on the receipt, or correct on screen but not in the
// posted transaction, is worse than no feature at all.

const SECONDARY = 'secondary';

export const isSecondaryTier = (diningOption) =>
    String(diningOption?.price_tier || '').toLowerCase() === SECONDARY;

// The fallback is deliberate and load-bearing: a secondary-tier option still
// sells at the primary price when no secondary is set. That way the tenant
// fills in a second price only for the products that genuinely differ, and a
// blank field can never sell something for nothing.
//
// Note the `== null` check rather than a truthiness test — an explicit
// secondary price of 0 is a real, intentional value (a free item on delivery),
// and `||` would silently charge full price for it.
export const resolveProductPrice = (product, diningOption) => {
    if (!product) return 0;

    if (isSecondaryTier(diningOption) && product.secondary_price != null) {
        const secondary = parseFloat(product.secondary_price);
        if (!Number.isNaN(secondary)) return secondary;
    }

    const primary = parseFloat(product.selling_price);
    return Number.isNaN(primary) ? 0 : primary;
};

export default resolveProductPrice;
